/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';
import Styles from '../../css/LoanDefaultCodes.module.css';

type TextProps = {
  label: string;
  value;
  name: string;
  disabled: boolean;
};

const textInput = (props: TextProps) => {
  const { LDCFunctions } = useLDCContext();
  const { label, value, name, disabled } = props;
  const { handleLDCChange } = LDCFunctions;
  return (
    <tr>
      <th>{label + ':'}</th>
      <td className={disabled ? Styles.disabled : ''}>
        {' '}
        {
          <input
            value={value}
            onChange={(e) => {
              handleLDCChange('edit', name, e.target.value);
            }}
            disabled={disabled}
            size={10}
          />
        }
      </td>
    </tr>
  );
};

export default textInput;
